import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, useMapEvents, Marker } from 'react-leaflet';
import { iconeNormal } from '../../assets/Icons/Icons';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStreetView } from '@fortawesome/free-solid-svg-icons';
export default function CustomizedMap({ markers, position, positionCenter, setPosition, addNewMarker, setPointSelected, zoom = 13 }) {
    const [map, setMap] = useState(null);
    const [center, setCenter] = useState([-23.2198396, -45.8915658]);
    const [viewSatelite, setViewSatelite] = useState(() => false);
    const toggleViewSatelite = () => setViewSatelite(() => !viewSatelite);
    function AddNewMarker({ mapRef }) {
        useMapEvents({
            click(e) {
                setPosition(e.latlng);
                mapRef.flyTo(e.latlng, mapRef.getZoom());
            },
            locationfound(e) {
                setCenter(e.latlng)
                mapRef.flyTo(e.latlng, mapRef.getZoom())
            },

        });
        return position !== null && position !== undefined && position.length !== 0 ?
            <Marker position={position} icon={iconeNormal}>

            </Marker>
            : <></>;
    }
    useEffect(() => {
        if (positionCenter && position.lat != "" && map) {
            const newCenter = [position.lat, position.lng];
            setCenter(newCenter);
            map.flyTo(newCenter);
        } else if (map) {
            const newCenter = [-23.2198396, -45.8915658];
            setCenter(newCenter);
            map.flyTo(newCenter);
        }
    }, [position, map])
    return (
        <div className='w-100 h-100 bg-warning position-relative'>
            <MapContainer
                center={center}
                zoom={zoom}
                ref={map}
                whenCreated={setMap}
                style={{ height: "100%", width: "100%", backgroundColor: "#333" }}

            >
                <TileLayer
                    url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                    attribution='© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, © <a href="https://carto.com/attribution">CARTO</a>'
                />
                {
                    viewSatelite
                    &&
                    <TileLayer
                        url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
                        maxZoom={20}
                        subdomains={['mt1', 'mt2', 'mt3']}
                    />

                }
                {markers && markers.map((value, index) => {

                    return (
                        <Marker key={index} icon={iconeNormal} position={value.coordenadas}
                            eventHandlers={{
                                click: (e) => {
                                    setCenter(e.latlng);
                                    map.flyTo(e.latlng);
                                    setPointSelected(value);
                                },
                            }}
                        >
                        </Marker>
                    )
                })}
                {addNewMarker && <AddNewMarker mapRef={map} />}
            </MapContainer>
            <Button color='light border' className='buttonSatelite' onClick={toggleViewSatelite}><FontAwesomeIcon size='1x' icon={faStreetView} /></Button>
        </div>
    )
}